import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-sky-500 hover:text-sky-600 font-medium mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
        
        <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8 md:p-12">
          <h1 className="text-3xl font-bold text-slate-900 mb-8">Política de Privacidad</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">
              Última actualización: {new Date().toLocaleDateString('es-AR')}
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">1. Información que Recopilamos</h2>
            <p className="text-slate-600 mb-4">
              Recopilamos información que usted nos proporciona directamente, incluyendo:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
              <li>Información de cuenta de Google (nombre, email, foto de perfil)</li>
              <li>Textos ingresados para análisis</li>
              <li>Historial de uso del servicio</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">2. Cómo Utilizamos la Información</h2>
            <p className="text-slate-600 mb-4">
              Utilizamos la información recopilada para:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
              <li>Proporcionar y mejorar nuestros servicios</li>
              <li>Personalizar su experiencia</li>
              <li>Mantener un historial de sus análisis</li>
              <li>Comunicarnos con usted sobre el servicio</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">3. Almacenamiento de Datos</h2>
            <p className="text-slate-600 mb-4">
              Sus datos se almacenan de forma segura utilizando Firebase de Google Cloud. 
              Los textos ingresados se procesan a través de la API de Google Gemini para generar análisis.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">4. Compartir Información</h2>
            <p className="text-slate-600 mb-4">
              No vendemos ni compartimos su información personal con terceros, excepto cuando sea 
              necesario para proporcionar el servicio (ej: procesamiento con Google AI).
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">5. Seguridad</h2>
            <p className="text-slate-600 mb-4">
              Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos 
              contra acceso no autorizado, alteración o destrucción.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">6. Sus Derechos</h2>
            <p className="text-slate-600 mb-4">
              Usted tiene derecho a:
            </p>
            <ul className="list-disc list-inside text-slate-600 mb-4 space-y-2">
              <li>Acceder a sus datos personales</li>
              <li>Solicitar la corrección de datos inexactos</li>
              <li>Solicitar la eliminación de sus datos</li>
              <li>Retirar su consentimiento en cualquier momento</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">7. Cookies</h2>
            <p className="text-slate-600 mb-4">
              Utilizamos cookies y tecnologías similares para mantener su sesión y mejorar 
              la experiencia del usuario.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">8. Contacto</h2>
            <p className="text-slate-600 mb-4">
              Para consultas sobre privacidad, puede contactarnos a través de{' '}
              <a href="https://masempatia.com" className="text-sky-500 hover:text-sky-600">masempatia.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
